import React, { useId } from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'

function InputField({ labelText, value, placeholder, type, required, onChange, multiline }) {
  const inputId = useId()

  return (
    <div className={styles.inputWrapper}>
      <label className={styles.label} htmlFor={inputId}>
        <Text type="caption-1">{labelText}</Text>
      </label>
      {
        multiline ?
          <textarea
            className={`${styles.textArea} ${styles.textAreaDark}`}
            id={inputId}
            value={value}
            placeholder={placeholder}
            required={required}
            onChange={(e) => onChange(e.target.value)}
          />
          :
          <input
            className={`${styles.input} ${styles.inputDark}`}
            id={inputId}
            value={value}
            type={type}
            placeholder={placeholder}
            required={required}
            onChange={(e) => onChange(e.target.value)}
          />
      }
    </div>
  )
}

export default InputField
